
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const SearchIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m20 20-3.624-3.624M4 11.25A7.25 7.25 0 1 0 11.25 4v0A7.25 7.25 0 0 0 4 11.25"/></svg>
  </SvgIcon>
);
